import axiosVApi from '../axiovishwam';

const getFormFieldDropdown = async (body) => {
    try {
        const response = await axiosVApi.post(`FormField/GetFormFieldDropDown`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getFormFieldDropdown===>:", error);
    }
};
const getFormFieldList = async (body) => {
    try {
        const response = await axiosVApi.post(`FormField/GetFormFieldList`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getFormFieldList===>:", error);
    }
};

const addFormField = async (body) => {
    try {
        const response = await axiosVApi.post(`FormField/CreateFormField`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addFormField ===>", error);
        return error?.response
    }
};
const updateFormField = async (body) => {
    try {
        const response = await axiosVApi.post(`FormField/UpdateFormField`, body);
        return response?.data;
    } catch (error) {
        console.log("Error updateFormField ===>", error);
    }
};

export const FormFieldService = {
    getFormFieldDropdown,
    getFormFieldList,
    addFormField,
    updateFormField,
};